import axios from 'axios';

import { mapTransferConfigurationResponse } from '@/mappers/transfer.mapper';

import apiClient from '@/lib/api-client';
import { raiseAxiosErrorOrDefault } from '@/lib/error';

import type {
  TransferConfiguration,
  TransferConfigurationUpdateRequest,
} from '@/types/transfer.type';

/**
 * Fetch the transfer configuration for an agent.
 * Returns `null` when the agent has no configuration yet (API responds 404).
 */
export const fetchTransferConfiguration = async (
  agentId: number
): Promise<TransferConfiguration | null> => {
  try {
    return await apiClient.get<TransferConfiguration>(
      `/transfer-configurations/${agentId}`,
      mapTransferConfigurationResponse
    );
  } catch (e) {
    if (axios.isAxiosError(e) && e.response?.status === 404) {
      return null;
    }
    raiseAxiosErrorOrDefault(e, 'Failed to fetch transfer configuration');
  }
};

/**
 * Create or update (upsert) the transfer configuration for an agent.
 */
export const upsertTransferConfiguration = async (
  agentId: number,
  payload: TransferConfigurationUpdateRequest
): Promise<TransferConfiguration> => {
  try {
    return await apiClient.put<TransferConfiguration>(
      `/transfer-configurations/${agentId}`,
      payload,
      mapTransferConfigurationResponse
    );
  } catch (e) {
    raiseAxiosErrorOrDefault(e, 'Failed to save transfer configuration');
  }
};
